import React from "react";
import styled from "styled-components";
import {
  BodyShortLargeStrong,
  BodyShortMediumStrong,
} from "./OnboardingTypography";
import { THEME } from "./OnboardingLayoutComponents";

const StepWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  justify-self: center;
  width: 100%;
  max-width: 550px;
  margin: 0 auto ${THEME.spacing.mega} auto;
  min-height: 60px;

  @media (max-width: 600px) {
    max-width: 100%;
    margin-bottom: ${THEME.spacing.xxl};
    min-height: 40px;
  }
`;

const Circle = styled.div.withConfig({
  shouldForwardProp: (prop) => !['active'].includes(prop),
})`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin: ${THEME.spacing.sm};
  background: ${({ active }) => (active ? THEME.colors.text : THEME.colors.white)};
  border: 2px solid ${({ active }) => (active ? THEME.colors.text : THEME.colors.selectedBg)};
  color: ${({ active }) => (active ? THEME.colors.white : THEME.colors.text)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: ${THEME.transitions.default};
`;

const Line = styled.div.withConfig({
  shouldForwardProp: (prop) => !['line'].includes(prop),
})`
  border-bottom: 2px solid ${({ line }) => (line ? THEME.colors.selectedBg : "transparent")};
  flex-grow: 1;
`;

const IndicatorContainer = styled.div`
  display: flex;
  margin: auto;
  width: 100%;
  align-items: center;
  flex: 1;
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  height: 100%;
`;

const StepLabel = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isActive'].includes(prop),
})`
  text-align: center;
  
  @media (max-width: 600px) {
    display: ${({ isActive }) => isActive ? 'block' : 'none'};
  }
`;

const StepIndicator = ({ activeStep, goToStep }) => {
  const steps = [
    { number: 1, label: "Velg økonomisystem" },
    { number: 2, label: "Opprett bruker" },
    { number: 3, label: "Kom i gang" },
  ];

  return (
    <StepWrapper>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <StepContainer>
            <IndicatorContainer>
              <Line line={index !== 0} />
              <Circle active={activeStep === step.number}>{step.number}</Circle>
              <Line line={index !== steps.length - 1} />
            </IndicatorContainer>
            <StepLabel isActive={activeStep === step.number}>
              <BodyShortMediumStrong
                onClick={() => goToStep(step.number)}
              >
                {step.label}
              </BodyShortMediumStrong>
            </StepLabel>
          </StepContainer>
        </React.Fragment>
      ))}
    </StepWrapper>
  );
};

export default StepIndicator;
